// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app'

const firebaseConfig = {
  apiKey: 'AIzaSyDGDvgrcIv1UzUU9F27Bz9nPHArv1xeHaM',
  authDomain: 'configurator-app-84c9b.firebaseapp.com',
  projectId: 'configurator-app-84c9b',
  storageBucket: 'configurator-app-84c9b.firebasestorage.app',
  messagingSenderId: '693166225710',
  appId: '1:693166225710:web:b6abe2166ea54e48fd62bf',
  measurementId: 'G-KSY3BBD1JD',
}

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig)

export default firebaseApp
